export default __webpack_public_path__ + "static/media/SH_Logo_Pink_Slogan.e7da4ad8.svg";